// extracted by mini-css-extract-plugin
module.exports = {"iconsBlock":"IconsBlock_iconsBlock__1UF9e","info":"IconsBlock_info__em7T_","item":"IconsBlock_item__2z3dt"};